import Spin from 'components/spin';
import Box from '@mui/material/Box';

type Props = {
  style?: any;
  size?: string;
  type?: 'small' | 'normal' | 'large';
};

export default function Loading({ style, size, type }: Props) {
  return (
    <Box
      sx={{
        height: '530px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...style,
      }}>
      <Spin size={size} type={type} />
    </Box>
  );
}
